import type { EventFighter } from "~/types/events.types";
import type { Database, Tables } from "~/types/types.gen";

export default function useEventsFightersDatabase() {
  const client = useSupabaseClient<Database>();
  const posthog = usePosthog();

  async function fetchEventFighters(
    eventId: string
  ): Promise<EventFighter[] | null> {

    const { data, error } = await usePrivateApiFetch()("/api/events/fighters", {
      method: "GET",
      params: {
        id: eventId,
      },
    });

    posthog.logError(error, "useEventsFightersDatabase:fetchEventFighters");

    if (error) throw error;

    return data as EventFighter[] | null;
  }

  async function insert(
    newRows: Tables<"events_fighters">[]
  ): Promise<EventFighter[]> {
    const { data, error } = await $fetch("/api/events/application_form/submit", {
      method: "POST",
      body: {
        data: newRows,
      },
    });

    posthog.logError(error, "useEventsFightersDatabase:insert");

    if (error) throw error;

    return data ?? [];
  }

  const update = async (changes: {}[]): Promise<EventFighter[]> => {
    const { data, error } = await $fetch(
      "/api/events/application_form/update",
      {
        method: "POST",
        body: {
          data: changes,
        },
      }
    );

    posthog.logError(error, "useEventsFightersDatabase:update");

    if (error) throw error;

    return data;
  };

  const remove = async (
    eventId: string,
    eventRegistrationId: string
  ): Promise<{
    removedFightCardId: string | null;
    modifiedFightCardData: Tables<"event_fight_cards"> | null;
  }> => {
    const { data, error } = await $fetch("/api/events/fighters/remove", {
      method: "DELETE",
      query: {
        id: eventRegistrationId,
        eventId: eventId,
      },
    });

    if (error) {
      posthog.logError(error, "useEventsFightersDatabase:remove");
      throw error;
    }

    return {
      removedFightCardId: data?.removedFightCardId ?? null,
      modifiedFightCardData: data?.modifiedFightCardData ?? null,
    };
  };

  return {
    fetchEventFighters,
    insert,
    update,
    remove,
  };
}
